import { render } from "./homeTeachEvaluation.vue?vue&type=template&id=8352cf28&scoped=true"
import script from "./homeTeachEvaluation.vue?vue&type=script&lang=js"
export * from "./homeTeachEvaluation.vue?vue&type=script&lang=js"

import "./homeTeachEvaluation.vue?vue&type=style&index=0&id=8352cf28&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8352cf28"]])

export default __exports__